<template>
    <UserEdit
        :showEditInfo="showEditInfo"
        @showModalEditDataUser="handleShowModalEditDataUser"
    />
    <div class="global_header weeducStudentHeader" :class="{ dark: dark }">
        <div class="logo">
            <router-link to="/aluno">
                <img v-show="!dark" src="../../../../../src/assets/logo.png" />
                <img
                    v-show="dark"
                    src="../../../../../src/assets/logo_white.png"
                />
            </router-link>
        </div>

        <div class="menu_mobile openSidebar">
            <fa icon="bars" @click="() => (showMenuMobile = !showMenuMobile)" />
        </div>

        <div class="options">
            <div class="menu item">
                <ul>
                    <li :class="{ active: activeIndex == 0 }" >
                        <router-link to="/aluno" class="itemMenuPortalAluno" @click="activeIndex = 0"> Início</router-link>
                    </li>
                    <li v-if="dataWebsitePortal2?.showInquiry==1" :class="{ active: activeIndex == 1 }">
                        <router-link to="/aluno/duvidas" class="itemMenuPortalAluno" @click="activeIndex = 1"
                            >Minhas dúvidas</router-link
                        >
                    </li>
                    <li v-if="dataWebsitePortal2?.showForum==1" :class="{ active: activeIndex == 2 }">
                        <router-link to="/aluno/forum" class="itemMenuPortalAluno" @click="activeIndex = 2">Fóruns</router-link>
                    </li>
                    <li v-if="dataWebsitePortal2?.showCertificate==1" :class="{ active: activeIndex == 3 }">
                        <router-link to="/aluno/certificados" class="itemMenuPortalAluno" @click="activeIndex = 3"
                            >Certificados</router-link
                        >
                    </li>
                    <li v-if="typeId == 2" :class="{ active: activeIndex == 4 }">
                        <router-link to="/dashboard/painel" class="itemMenuPortalAluno" @click="activeIndex = 4"
                            >Painel Administrativo</router-link
                        >
                    </li>
                </ul>
            </div>

            <div class="menu icone_actions">
                <ul>
                    <li style="position: relative">
                        <!-- Clique no sino abre/fecha a notificação sem fechar imediatamente -->
                        <fa icon="fa-bell" @click.stop="showNotification" />
                        <span class="qtd_notification">{{
                            qtdnotification
                        }}</span>
                        <div
                            class="notification_bar"
                            :class="{ show: hasNotification, dark: dark }"
                            ref="notificationContainer"
                        >
                            <Notification :data="data" title="Notificações" @unread-count-updated="updateNotificationCount" />
                        </div>
                    </li>

                    <li @click="changeViewMode()">
                        <span v-if="dark"><fa icon="sun" /></span>
                        <span v-if="!dark"><fa icon="moon" /></span>
                    </li>

                    <li @click="() => $router.push('/aluno/perfil')">
                        <span class="logo_name">{{ name }}</span>
                    </li>

                    <li @click="logout">
                        <fa icon="fa-power-off" />
                    </li>
                </ul>
            </div>
        </div>

        <MobileMenu :showMenuMobile="showMenuMobile" @fechar-menu-header="closeMenu"  v-if="showMenuMobile"/>
        
    </div>
</template>

<script>
    import UserEdit from '@/components/Student/Dashboard_Unique/Info_User/user.vue';
    import Notification from './Notifications.vue';
    import { mapState, mapActions } from 'vuex';
    import api from '@/utils/portal/notification.js';
    import MobileMenu from './mobileMenu.vue';

    export default {
        data() {
            return {
                showEditInfo: false,
                hasNotification: false,
                qtdnotification: 0,
                data: [],
                showNavItem: false,
                name: null,
                fullName: null,
                showMenuMobile: false,
                userLoaded: false,
                activeIndex: 0,
            };
        },

        components: {
            Notification,
            UserEdit,
            MobileMenu,
        },

        computed: {
            ...mapState(['token', 'typeId', 'user', 'dark']),
            ...mapState('portal', ['dataWebsitePortal2']),
        },

        watch: {
            user: {
                handler(newVal) {
                    if (newVal && newVal.name) {
                        this.loadDataUser();
                        this.userLoaded = true;
                    }
                },
                immediate: true,
                deep: true,
            },
            token: {
                handler(newVal) {
                    if (newVal) {
                        this.getNumberNitification();
                        this.getDataNotification();
                    }
                },
                immediate: true,
            },
            showMenuMobile(val) {
                document.body.style.overflow = val ? 'hidden' : '';
            },
        },

        methods: {
            ...mapActions(['toggleDarkMode', 'restoreDarkMode']),

            async loadDataUser() {
                // Só executa se o user existir e tiver o campo name
                if (this.user && this.user.name) {
                    this.fullName = this.user.name;
                    this.name = this.user.name.substring(0, 2);
                } else {
                    this.fullName = '';
                    this.name = '';
                }
            },

            async getDataNotification() {
                try {
                    console.log('Carregando notificações...');
                    const response = await api.getDataNotifications(this.token);
                    console.log('Resposta da API de notificações:', response);
                    this.data = response;
                    console.log('Dados de notificação definidos no Header:', this.data);
                } catch (error) {
                    console.error('Erro na listagem das notificações:', error);
                }
            },

            async getNumberNitification() {
                try {
                    const response = await api.getNumberNotifications(
                        this.token
                    );
                    this.qtdnotification = response;
                } catch (error) {
                    console.error('Erro ao buscar número de notificações:', error);
                }
            },

            updateNotificationCount(count) {
                this.qtdnotification = count;
            },

            logout() {
                localStorage.removeItem('vuex');
                localStorage.removeItem('activeIndex');
                localStorage.removeItem('logado');
                window.location.href = '/portal';
                // Restaura o dark mode após limpar o localStorage
                this.restoreDarkMode();
            },

            handleShowModalEditDataUser(showEditInfo) {
                this.showEditInfo = showEditInfo;
            },

            changeViewMode() {
                const darkLocal = !this.dark;
                this.toggleDarkMode({ dark: darkLocal });
            },

            showNotification() {
                console.log('Clique no sino - hasNotification antes:', this.hasNotification);
                this.hasNotification = !this.hasNotification;
                console.log('Clique no sino - hasNotification depois:', this.hasNotification);
                console.log('Dados disponíveis:', this.data);
            },

            closeMenu() {
                this.showMenuMobile = false;
            },

            handleClickOutside(event) {
                const clickedOutsideNotification =
                    this.$refs.notificationContainer &&
                    !this.$refs.notificationContainer.contains(event.target);

                if (clickedOutsideNotification) {
                    this.hasNotification = false;
                }
            },
        },

        mounted() {
            document.addEventListener('click', this.handleClickOutside);
            
            // Verificar se o token está disponível antes de fazer as chamadas
            if (this.token) {
                this.getNumberNitification();
                this.getDataNotification();
            } else {
                // Tentar novamente após um pequeno delay
                this.$nextTick(() => {
                    if (this.token) {
                        this.getNumberNitification();
                        this.getDataNotification();
                    }
                });
            }
            
            // Não chama loadDataUser diretamente aqui, pois pode não ter carregado o user ainda
            if (this.user && this.user.name) {
                this.loadDataUser();
                this.userLoaded = true;
            }

            if (this.dark) {
                document.body.classList.add('dark');
            } else {
                document.body.classList.remove('dark');
            }
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
        },
    };
</script>

<style scoped>
    @import url(./index.css);
    .menu_mobile,
    .menuMobile {
        display: none;
    }
    @media only screen and (max-width: 600px) {
        .menu_mobile {
            display: flex;
            gap: 10px;
        }
        .menuMobile {
            display: block;
        }
        .options {
            display: none;
        }
        .global_header {
            padding: 5px 10px;
            align-items: center;
        }
        i.pi.pi-bars {
            font-size: 25px;
        }
        .menuMobile {
            position: fixed;
            width: 50%;
            background-color: white;
            top: 0;
            right: 0;
            height: 100%;
            z-index: 10;
            right: -500px;
            overflow-y: auto;
            transition: right 0.5s ease;
            box-shadow: 0px 0px 20px 1px #d0d0d0;
        }

        .menuMobile.show {
            right: 0;
        }
        .logoMobile {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px;
        }
        .logoMobile img {
            width: 150px;
        }
        .menuMobile ul {
            padding: 10px;
        }
        .menuMobile ul li {
            list-style: none;
            text-align: left;
            padding: 10px 0px;
        }
        .menuMobile ul li a {
            font-size: 18px;
            text-decoration: none;
            color: #666666;
            font-weight: 400;
            display: flex;
            gap: 10px;
            align-items: center;
        }
        .dark .menuMobile ul li a {
            color: white;
        }
        li.viewmode span {
            display: flex;
            gap: 5px;
            align-items: center;
        }
        span.fullName {
            text-transform: capitalize;
        }
        .dark .menuMobile.show {
            background-color: black;
            box-shadow: 0px 0px 20px 1px #000000;
        }
    }
    .global_header.weeducStudentHeader .item {
        background-color: white !important;
    }
    /* DARK */
    .global_header.weeducStudentHeader.dark .item {
        background-color: #0d0d0d !important;
        color: #ffffff !important;
    }
    .menu.icone_actions > ul > li {
        cursor: pointer;
    }
    .menu_mobile.openSidebar {
        position: absolute;
        top: 18px;
        right: 10px;
    }
    .menu.item li{
        min-width: 100px;
    }
    li.active {
        position: relative;
        transition: all 0.3s ease;
    }
    li.active:after {
        content: "";
        position: absolute;
        display: block;
        width: 100%;
        height: 3px;
        background-color: #19c7d0;
    }    
</style>
